// extracted by mini-css-extract-plugin
module.exports = {"collection":"ConsentsCollection_collection__1tTuA","item":"ConsentsCollection_item__Ta318","header":"ConsentsCollection_header__AtnIa"};